import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { CheckCircle, FileCheck, Globe, Building } from 'lucide-react';

export default function CompliancePage() {
  const frameworks = [
    {
      icon: Globe,
      title: 'Global Privacy Laws',
      items: ['GDPR', 'CCPA/CPRA', 'PIPEDA', 'LGPD']
    },
    {
      icon: Building,
      title: 'Industry Standards',
      items: ['ISO 27701', 'NIST Privacy Framework', 'APEC Privacy Framework']
    },
    {
      icon: FileCheck,
      title: 'Assessment Methodologies',
      items: ['DPIA Guidelines', 'Privacy by Design', 'Risk Assessment Frameworks']
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-8">Compliance</h1>
          
          <div className="bg-white rounded-lg shadow-sm p-8 space-y-12">
            <section>
              <h2 className="text-2xl font-semibold mb-6">Our Compliance Framework</h2>
              <p className="text-gray-600">
                TurboPIA privacy assessments are built on comprehensive compliance frameworks that align with global 
                privacy regulations and industry best practices.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-6">Supported Frameworks</h2>
              <div className="grid md:grid-cols-3 gap-6">
                {frameworks.map((framework, index) => (
                  <div key={index} className="p-6 border border-gray-100 rounded-lg hover:border-brand-primary transition-colors">
                    <div className="flex items-center mb-4">
                      <framework.icon className="h-6 w-6 text-brand-primary mr-3" />
                      <h3 className="text-lg font-semibold">{framework.title}</h3>
                    </div>
                    <ul className="space-y-2">
                      {framework.items.map((item, idx) => (
                        <li key={idx} className="flex items-center text-gray-600">
                          <CheckCircle className="h-4 w-4 text-brand-primary mr-2" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-6">Compliance Updates</h2>
              <p className="text-gray-600 mb-4">
                Our compliance frameworks are continuously updated to reflect:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>New privacy regulations and amendments</li>
                <li>Updated regulatory guidance</li>
                <li>Emerging industry standards</li>
                <li>Best practices in privacy assessment</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-6">Contact Our Compliance Team</h2>
              <p className="text-gray-600">
                For compliance-related inquiries, please contact us at{' '}
                <a href="mailto:compliance@pqstart.com" className="text-brand-primary hover:text-brand-dark">
                  compliance@TurbopPIA.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}